import type { DayOfWeek } from "@repo/api";

// Slot & duration defaults
export const DEFAULT_SLOT_DURATION_MINUTES = 30;
export const DEFAULT_SCHEDULE_SLOT_DURATION = { value: 15, unit: "min" } as const;

// Booking defaults

// Availability sentinels
export const ALWAYS_AVAILABLE_START = "00:00";
export const ALWAYS_AVAILABLE_END = "00:00";
export const ALL_DAY_END = "23:59";
export const ALL_DAYS: DayOfWeek[] = ["mon", "tue", "wed", "thu", "fri", "sat", "sun"];

// Calendar UI
export const DEFAULT_CALENDAR_SLOT_HEIGHT = 60;

// Timeslot thresholds (slot height → step/timeslots config)
export const TIMESLOT_THRESHOLDS = [
  { maxHeight: 90, step: 30, timeslots: 2 },
  { maxHeight: 150, step: 15, timeslots: 4 },
  { maxHeight: 240, step: 10, timeslots: 6 },
] as const;
export const TIMESLOT_FINEST = { step: 5, timeslots: 12 } as const;
